import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EntityService } from 'app/services/data/entity.service';

@Component({
    selector: 'app-dialog-conversion',
    templateUrl: './dialog-conversion.component.html',
    styleUrls: ['./dialog-conversion.component.scss']
})
export class DialogConversionComponent implements OnInit {
    loading: boolean = false;
    form: UntypedFormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogConversionComponent>,
        private translate: TranslateService,
        private fb: UntypedFormBuilder,
        private toastr: ToastrService,
        private entityService: EntityService
    ) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            firstName: this.fb.control(null, Validators.required),
            lastName: this.fb.control(null, Validators.required),
            phoneNumber: this.fb.control(null, Validators.required)
        });
    }

    close() {
        this.dialogRef.close();
    }

    askToBeCalled() {
        this.loading = true;
        this.entityService.sendUserRequest({ data: this.form.value, type: 'askToBeCalledBack' })
            .subscribe(
                () => {
                    this.toastr.success(this.translate.instant('COMMON.TOAST.SUCCESS_TITLE'));
                    this.loading = false;
                    this.dialogRef.close(true);
                },
                () => {
                    this.loading = false;
                    this.dialogRef.close(true);
                }
            );
    }
}
